import { Delimiter } from 'src/shared/design-system/Utilities/TextReplace';

export const closeText = 'Close';

export const followHeader = `You are Following Shef ${Delimiter}`;

export const followingText = `Following a shef allows you to stay up to date on the their availability, new upcoming dishes, and much more!`;
